import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  batchBills: 'BatchBills',
  bills: 'Bills',
  inboundTickets: 'InboundTickets',
  payments: 'Payments',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.batchBills, TAG_TYPES.bills, TAG_TYPES.inboundTickets],
  endpoints: {
    getBatchBills: {
      providesTags: [{ type: TAG_TYPES.batchBills, id: 'LIST' }],
    },
    getBatchBill: {
      providesTags: (result, error, { batchBillId }) => {
        const paymentTags = result?.bills
          ?.flatMap(bill => bill.paymentIds)
          ?.map(paymentId => ({ type: TAG_TYPES.payments, id: paymentId }))

        return [{ type: TAG_TYPES.batchBills, id: batchBillId }, ...(paymentTags || [])]
      },
    },
    createBatchBill: {
      invalidatesTags: [
        { type: TAG_TYPES.batchBills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: 'LIST' },
      ],
    },
    updateBatchBill: {
      invalidatesTags: (result, error, { batchBillId, billIds }) => {
        const billTags = billIds?.map(billId => ({
          type: TAG_TYPES.bills,
          id: billId,
        }))
        return [
          { type: TAG_TYPES.batchBills, id: 'LIST' },
          { type: TAG_TYPES.batchBills, id: batchBillId },
          { type: TAG_TYPES.bills, id: 'LIST' },
          ...(billTags || []),
        ]
      },
    },
    payBatchBill: {
      invalidatesTags: (result, error, { batchBillId, billIds }) => {
        const additionalTags = billIds?.flatMap(billId => [
          { type: TAG_TYPES.bills, id: billId },
          { type: TAG_TYPES.inboundTickets, id: billId }, // This will invalidate the inbound tickets that have this billId. See the "providesTags" for getInboundTicket
        ])
        return [
          { type: TAG_TYPES.batchBills, id: 'LIST' },
          { type: TAG_TYPES.batchBills, id: batchBillId },
          { type: TAG_TYPES.bills, id: 'LIST' },
          { type: TAG_TYPES.inboundTickets, id: 'LIST' },
          ...(additionalTags || []),
        ]
      },
    },
  },
})

export const {
  useGetBatchBillsQuery,
  useGetBatchBillQuery,
  useCreateBatchBillMutation,
  useUpdateBatchBillMutation,
  usePayBatchBillMutation,
} = api
